import { useTranslation } from "react-i18next"
import { VisuallyHidden } from "@radix-ui/react-visually-hidden"

import Icon from "@/components/Icon"
import { Button } from "@/components/ui/button"
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"
import { routesConfig } from "@/config/routes"

const styles = {
  childrenContainer: "px-4 pb-6 flex gap-x-4 items-start",
  textContainer:
    "flex flex-col gap-y-4 font-body-medium-regular text-neutral-700 grow",
  heading: "font-h3-bold",
  iconContainer: "text-danger-300 bg-danger-100 rounded-full p-1",
}

const NavigateWithContactModal = ({
  onClose,
}: {
  onClose: (value: boolean | null) => void
}) => {
  const { t } = useTranslation()

  const onClick = () => {
    onClose(true)
    // Rather than using client-side `navigate`, trigger a full reload to fix issues related when inconsistent state
    // when the agent state was changed in another window or in the AWS Connect panel
    window.location.href = routesConfig.AUTOMATIC_CALL_PANEL
  }

  return (
    <DialogContent>
      <DialogHeader>
        <VisuallyHidden>
          <DialogTitle>{t("global.modals.redirect.title")}</DialogTitle>
        </VisuallyHidden>
      </DialogHeader>
      <DialogBody>
        <div className={styles.childrenContainer} data-unmask>
          <div className={styles.iconContainer}>
            <Icon name="alert" size="sm" />
          </div>
          <div className={styles.textContainer}>
            <h3 className={styles.heading}>
              {t("global.modals.redirect.title")}
            </h3>
            <p>{t("global.modals.redirect.description")}</p>
          </div>
        </div>
      </DialogBody>
      <DialogFooter data-unmask>
        <Button type="button" onClick={onClick}>
          {t("global.button.goBack")}
        </Button>
      </DialogFooter>
    </DialogContent>
  )
}

export default NavigateWithContactModal
